import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export function Protected({ role, children }) {
  const { user, checked } = useAuth();
  const loc = useLocation();
  if (!checked) {
    return (
      <div className="py-20 text-center text-[13px] text-[#132C44]/60">
        Cargando…
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/english-id/login" replace state={{ from: loc }} />;
  }
  if (role && user.role !== role) {
    return <Navigate to="/english-id" replace />;
  }
  return children;
}
